import { render, staticRenderFns } from "./DialogDeleteSession.vue?vue&type=template&id=ee2935d0"
import script from "./DialogDeleteSession.vue?vue&type=script&lang=js"
export * from "./DialogDeleteSession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports